import { render } from "./CodeSummit.vue?vue&type=template&id=01ab0492&scoped=true"
import script from "./CodeSummit.vue?vue&type=script&lang=js"
export * from "./CodeSummit.vue?vue&type=script&lang=js"

import "./CodeSummit.vue?vue&type=style&index=0&id=01ab0492&scoped=true&lang=scss"

import exportComponent from "/home/forge/test.rwandabuildprogram.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ab0492"]])

export default __exports__